import {useEffect, useLayoutEffect, useState} from "react";
import {  GetContractorById, UpdateContractor
} from "../../../../../reduxToolkit/EmployeeContractors/EmployeeContractorsApi";
import {Contractor} from "../../../../../models/Contractor";
import {toast} from "react-toastify";
import {GetAllServiceType} from "../../../../../reduxToolkit/ServiceType/ServiceTypeApi";
import {getPhotoPicker} from '../../../../../components/PhotoPicker/SubComponent/Models/Models';
import {errorMsg, isEmailFormat, isPhoneFormat, isValidLengthDocumentId} from '../../../../../Apis/functions';
import routes from '../../../../../Routes/routes';
import {useLocation} from 'react-router-dom';
import { useSelector } from "react-redux";
import { EXTRA_DATA } from "../../../Company/Employees/Model/Models";
import { GetUserRestriction } from "../../../../../reduxToolkit/restrictions/RestrictionApi";
import HandleChange from './../../../../../Helpers/HandleChange';
import { GetSingleUserProvider } from './../../../../../reduxToolkit/Providers/providersApi';
/**
 * @Email : kpozos@ibl.mx
 * @Author: Karen Yunuen Pozos Arias
 * @jobTittle: Full Stack Developer
 *
 */

export const EmployeeFlowContractorUpdateApp = ({
    t,
    params,
    dispatch,
    navigate,
    workShiftsList,
    customizedList,
    setEmptyFields,
    isValidDob,
    isValidPassword,
    photoPicker,
    permission,
    setWorkShiftsList,
    setCustomizedList,
    setSecretModal,
    setSecretKey,
    setSteps,
    modified,
    setModified,
    setPhotoPicker,
    setExtraData,
    headersList, 
    extraData,
    extraDataEnabled,
    setExtraDataEnabled
}) => {
    const location = useLocation();
    let { state } = location;

    const [getAllServiceType, setGetAllServiceType] = useState([]);
    const [user, setUser] = useState({ ...Contractor });
     const [showUnlinkBtn, setShowUnlinkBtn] = useState(false);



    /**
     * Generates the steps for the employee update flow.
     * Includes "other_details" step only if extra data is enabled.
     */
    const STEP_EMPLOYEE_UPDATE = (extraDataEnabled) => {
        if (extraDataEnabled) {
            return [t('company_details'),  t('manager_details'), t('other_details'), t('photo'), t('access_right')];
        }
        return [t('company_details'), t('manager_details'), t('photo'), t('access_right')];
    };

    /**
     * Updates the steps whenever extraDataEnabled, permission, or translations change.
     * Ensures UI reflects the correct flow dynamically.
     */
    useLayoutEffect(() => {
        setSteps([...STEP_EMPLOYEE_UPDATE(extraDataEnabled)]);
    }, [extraDataEnabled, permission, t]);

    /**
     * Fetch initial data on component mount:
     * - Service types list
     * - User restrictions to determine if extra data is enabled
     */
    useEffect(() => {
        dispatch(GetAllServiceType()).then(
            ({
                payload: {
                    data: { data },
                },
            }) => {
                setGetAllServiceType(data);
            },
        );
        dispatch(GetUserRestriction()).then(
            ({
                payload: {
                    data: { data, success },
                },
            }) => {
                if (success === true) {
                    setExtraDataEnabled(data?.extraDataContractor);
                }
            },
        );
    }, [dispatch]);

    // Form handeler Function
    const FormHandler = () => {
        const emailOk = isEmailFormat(user.email);
        const phoneOk = isPhoneFormat(user.phoneNumber);

        if (!user.isValid() ||
            !isValidDob ||
            !phoneOk ||
            !emailOk ||
            !isValidPassword
          
        ) {
            toast.warn(t('please_fill_all_fields'));
            setEmptyFields(true);
        } else {
            setEmptyFields(false);
            updateContractor();
        }
    };

    const updateContractor = () => {
        const customs = customizedList
            .filter((element) => element.added === true && element.new === true)
            .map(({ zoneId, zoneName, dayId, from, to }) => ({
                zoneId: zoneId,
                zoneName: zoneName,
                dayId: dayId,
                from: from,
                to: to,
            }));

        let imageFile = getPhotoPicker(photoPicker);
        const addPw = user?.password?.trim() !== '' && user?.password !== null;
        const requestData = {
            data: {
                ...user.toCreateUpdate(addPw ? user?.password.trim() : null, extraData),
                workShifts: workShiftsList,
                customs,
            },
            file: imageFile,
            updateImage: !!user.selfie,
            setModified,
        };
        dispatch(UpdateContractor(requestData)).then(
            ({
                payload: {
                    data: { success, data, code },
                },
            }) => {
                if (success) {
                    if (data?.secret && addPw) {
                        setSecretModal(true);
                        setSecretKey(data?.secret);
                    }
                    toast.success(t('has_been_updated_successfully'));
                    setEmptyFields(false);
                } else {
                    errorMsg(code);
                }
            },
        );
    };

    useEffect(() => {
        getContractorInfo();
    }, []);

    useEffect(() => {
        if (modified) {
            getContractorInfo();
            setModified(false);
        }
    }, [modified]);

    const getContractorInfo = () => {
        dispatch(GetContractorById(params?.id)).then(
            ({
                payload: {
                    data: { data, success },
                },
            }) => {
                if (success === true) {
                    const deviceId = data?.deviceId ?? null;
                    setUser((prevData) => ({
                        ...prevData,
                        ...data,
                    }));
                    setShowUnlinkBtn(!!deviceId);
                    setExtraData(data?.extraData);
                    if (data?.selfie) {
                        setPhotoPicker((prev) => ({
                            ...prev,
                            previewImage: `data:image/jpeg;base64,${data.selfie}`,
                        }));
                    }
                    if (data?.customs?.length > 0) {
                        setCustomizedList(data?.customs?.map((item) => ({ ...item, added: true, new: false })));
                    }
                    if (data?.workShifts?.length > 0) {
                        setWorkShiftsList(
                            data?.workShifts.map((shift) => ({
                                ...shift,
                                added: true,
                                new: false,
                            })),
                        );
                    }
                    
                }
            },
        );
    };

    const goBack = () => {
        if (state?.backUrl) {
            navigate(state.backUrl, {
                state: { ...state },
            });
        } else {
            navigate(routes.contractor.list);
        }
    };

    /**
     * This function handles changes in the form fields for extra data. It updates the 'extraData' state by spreading the previous data
     * and updating the specific field (identified by 'name') with the new value from the form input.
     */
     
    const { handleChange } = HandleChange({
    model: extraData,
    setModel: setExtraData,
    });

    return {
        user,
        setUser,
        FormHandler,
        getAllServiceType,
        goBack,
        extraData,
        handleChange,
        setExtraData,
        showUnlinkBtn
    };
};;;
